import { createClient, SupabaseClient } from "@supabase/supabase-js";
import React, { ReactElement, useContext } from "react";
import { Database } from "./database.types";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

const supabase = createClient<Database>(
  SUPABASE_URL as string,
  SUPABASE_ANON_KEY as string,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
    },
  }
);
export const SupabaseContext = React.createContext(supabase);

// Provider component that wraps your app and makes an API call to fetch remaining credits
export const SupabaseProvider = ({ children }: { children: ReactElement }) => {
  return (
    <SupabaseContext.Provider value={supabase}>
      {children}
    </SupabaseContext.Provider>
  );
};

// Custom hook to use the supabase client
export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (context === undefined) {
    throw new Error("useSupabase must be used within a SupabaseProvider");
  }
  return context;
};

export const signInWithGoogle = async (
  redirectUrl: string,
  client: SupabaseClient<Database>
) => {
  // Supabase will redirect to this URL after OAuth completes
  const { data, error } = await client.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: redirectUrl,
    },
  });

  return data;
};

export default supabase;
